import React, { useCallback } from 'react'
import { Pressable } from 'react-native'

import { styled } from 'nativewind'

import { useSelectContext } from './useSelectContext'

const OptionContainer = styled(Pressable)
interface IRadio {
  name: string
  children: React.ReactNode
}
export function Radio({ name, children }: IRadio) {
  const { dispatch, state } = useSelectContext()

  const isSelected = useCallback(
    (value: string) => {
      if (state.mode === 'single') {
        return value === state.selectedItem
      } else {
        return state.selectedItem?.includes(value)
      }
    },
    [state.selectedItem, state.mode]
  )

  const getIconType = useCallback(
    (value: string) => {
      if (state.mode === 'single') {
        if (isSelected(value)) return 'RadioOn'
        else return 'RadioOff'
      }
      if (state.mode === 'multi') {
        if (isSelected(value)) return 'CheckBoxTickOutlined'
        else return 'CheckBox'
      }
    },
    [state.selectedItem]
  )

  return (
    <OptionContainer
      onPress={() => {
        dispatch({ type: 'SELECT_ITEM', item: name })
      }}
    >
      {React.cloneElement(children, { selected: isSelected(name) })}
    </OptionContainer>
  )
}
